<template>
 
        <div class="pa-4 " style="width: 100%; z-index:5">
            <div class="heatmap-container " style="z-index:5">
                <l-map
                    ref="map"
                    :zoom="zoom"
                    :center="center"
                    :options="{scrollWheelZoom: false, attributionControl: false}"
                    style="height: 100%; width: 100%"
                    @ready="onMapReady"
                >
                    <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                    ></l-tile-layer>
                </l-map>
            </div>
            <!-- <div class="ml-3 d-flex flex-grow-1 mt-4" style="width:calc(15% - 1px);">
                <div style="background:linear-gradient(0deg, rgba(0, 0, 255, 0.1), rgba(0, 255, 255, 0.3),rgba(0, 255, 0, 0.5), rgba(255, 255, 0, 0.7), rgba(255, 0, 0, 1)); height:125px; width: 25px;"></div>
                <div style="width: calc(100% - 30px); height:125px;" class="d-flex flex-column justify-space-between ml-2">
                    <p class="mb-0">{{ $t('highDensity') }}</p>
                    <p class="mb-0">{{ $t('lowDensity') }}</p>
                </div>
            </div> -->
        </div>
</template>

<script>
import { LMap, LTileLayer } from 'vue2-leaflet'
import L from 'leaflet'
import 'leaflet.heat'

export default {
    name: 'heatMapComponent',
    components: {
        LMap,
        LTileLayer
    },
    props: ['data'],
    data() {
        return {
            zoom: 5,
            zoomControl: false,
            center: [46.2276, 2.2137], // Centre de la France
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '',
            heatLayer: null,
            defaultData: [],
            heatmapOptions: {
                radius: 3,
                blur: 5,
                maxZoom: 17,
                max: 1.0,
                minOpacity: 1,
                gradient: {
                    0.0: 'rgba(0, 0, 255, 1)',
                    0.3: 'rgba(0, 255, 255, 1)',
                    0.5: 'rgba(0, 255, 0, 1)',
                    0.7: 'rgba(255, 255, 0, 1)',
                    1.0: 'rgba(255, 0, 0, 1)'
                }
            }
        }
    },
    computed: {
        heatData() {
            return this.data && this.data.values && this.data.values.length > 0 ? this.data.values : []
        }
    },
    methods: {
        onMapReady() {
            this.$nextTick(() => {
                // Activer le zoom avec CTRL+molette
                const map = this.$refs.map.mapObject
                
                // Désactiver le zoom par défaut
                map.scrollWheelZoom.disable()
                
               // Récupérer le conteneur DOM de la carte
                const mapContainer = map.getContainer()
                
                // Intercepter l'événement wheel natif du DOM
                mapContainer.addEventListener('wheel', (e) => {
                    if (e.ctrlKey) {
                        // Empêcher le zoom du navigateur
                        e.preventDefault()
                        e.stopPropagation()
                        
                        // Zoomer la carte
                        if (e.deltaY < 0) {
                            map.zoomIn()
                        } else {
                            map.zoomOut()
                        }
                    }
                }, { passive: false }) // passive: false est crucial pour preventDefault()
                this.addHeatmapLayer()
            })
        },
        addHeatmapLayer() {
            if (this.heatLayer) {
                this.$refs.map.mapObject.removeLayer(this.heatLayer)
            }
            
            this.heatLayer = L.heatLayer(this.heatData, this.heatmapOptions)
            this.heatLayer.addTo(this.$refs.map.mapObject)
        }
    },
    watch: {
        heatData: {
            handler() {
                this.addHeatmapLayer()
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.heatmap-container {
    width: 100%;
    height: 500px;
    position: relative;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* Styles pour les marqueurs Leaflet */
.leaflet-container {
    font-family: inherit;
    height: 100% !important;
}

/* Personnalisation de la heatmap */
.leaflet-heatmap-layer {
    opacity: 0.9;
}
</style>

<style>
/* Styles globaux pour Leaflet */
@import '~leaflet/dist/leaflet.css';

.leaflet-container {
    height: 100%;
    width: 100%;
}
</style>